import { useEffect } from 'react';

import { LayoutContainer } from '@selina-finance/ui';
import clsx from 'clsx';
import { Outlet, useLocation } from 'react-router-dom';

import Footer from '@Components/Footer/Footer';
import Header from '@Components/Header/Header';
import ProgressMenu from '@Components/Progress/ProgressMenu';
import Trustbar from '@Components/Trustbar/Trustbar';
import { useSessionExpiryGuard } from '@src/shared/hooks/useSessionExpiryGuard';

const SharedLayout = () => {
    const location = useLocation();

    const isApprovedPage = location.pathname === '/approved';
    const showTrustbar = !isApprovedPage;

    const showProgressMenu = !(
        location.pathname === '/expired' ||
        location.pathname === '/not-found' ||
        location.pathname === '/existing-loan' ||
        location.pathname === '/declined' ||
        location.pathname === '/concurrent-applications' ||
        location.pathname === '/approved'
    );

    useSessionExpiryGuard();

    useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }, [location.pathname]);

    return (
        <div className='flex min-h-screen flex-col bg-almond-100 text-lg'>
            <Header />
            {showTrustbar && <Trustbar />}
            {showProgressMenu && (
                <div className='w-full lg:hidden'>
                    <ProgressMenu />
                </div>
            )}
            <LayoutContainer
                className={clsx(
                    'flex-1 pt-8 pb-8 lg:pt-12 lg:pb-20',
                    showProgressMenu ? null : 'items-center',
                    isApprovedPage &&
                        'bg-peppermint-400 lg:bg-peppermint-500 px-0 md:max-w-none',
                )}
            >
                <div
                    className={clsx(
                        'flex flex-col',
                        showProgressMenu
                            ? 'gap-6 lg:grid lg:grid-cols-layout lg:items-start lg:gap-6'
                            : 'items-center',
                    )}
                >
                    <main
                        className={clsx(
                            showProgressMenu
                                ? 'order-2 lg:order-none lg:col-span-1 lg:col-start-1'
                                : 'w-full',
                        )}
                    >
                        <Outlet />
                    </main>
                    {showProgressMenu && (
                        <>
                            <div className='hidden lg:block lg:col-span-1 lg:col-start-2' />
                            <div className='hidden lg:block lg:col-span-1 lg:col-start-3'>
                                <ProgressMenu />
                            </div>
                        </>
                    )}
                </div>
            </LayoutContainer>
            <Footer />
        </div>
    );
};

export default SharedLayout;
